<template>
  <v-container fluid pt-0 px-0>
    <template v-if="isBreadcrumbsShow()">
      <v-breadcrumbs :items="items" class="grey lighten-5 py-3">
        <template slot="item" slot-scope="props">
          <router-link tag="a" :to="{ name: props.item.route }" :class="[props.item.disabled && 'grey--text text-lighten-1 disabled']">
            {{ $t(`${props.item.text}`) }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </template>
    <v-container fluid grid-list-lg px-6 mt-3>
      <v-layout row wrap mx-0 pb-2 class="d-flex align-center text-uppercase text-h6 font-weight-bold">      
          <slot name="header"></slot>
         <slot name="button" ></slot>         
        <slot name="back"></slot>
      </v-layout>
      <hr class="mb-3">
      <slot></slot>
    </v-container>
  </v-container>
</template>

<script>
import { Menu } from './_nav.js';

export default {
  data() {
    return {
      items: [
        {
          text: 'dashboard',
          disabled: false,
          route: 'dashboard'
        },
      ]
    }
  },
  mounted() {
    this.breadcrumbsInit(Menu);
  },
  methods: {
    isBreadcrumbsShow() {
      if (this.$route.name == 'dashboard' || this.$route.path == '/') return false;
      return true;
    },
    breadcrumbsInit(menus) {
      const path = this.$route.name;


      if (menus.length > 0) {
        menus.forEach(menu => {
          const { title: text, items, route } = menu;
          // check for single or nested routes to append breadcrumbs
          if (items && items.length > 0) {
            items.forEach(item => {
              if (item.route == path) this.addBreadcrumbs(item);
            });
          } else {
            if (route == path) this.addBreadcrumbs(menu);
          }
        });
      }
    },
    addBreadcrumbs(item) {
      const { title: text, route } = item;
      this.items.push({ text, route, disabled: true });
    },
  }
}
</script>
